
import React, { Component } from 'react';
import services from '../../../services';
import $ from 'jquery'
import TlkTable from '../../../components/tlelrik/table/tlkTable';
import RightPopModalForm from '../../../components/common/RightPopModalForm';
import ParcelVirsion from '../../../components/Parcel-Right-panel/ParcelVirsion';
import jsPDF from "jspdf";
const queryString = require('query-string');
var moment = require('moment')
const dateFormat = "DD-MM-YYYY";
const fullDateFormat = "DD-MM-YYYY HH:mm:ss";
let listdefaultRequest = { Filters: null, "SortBy": "id", "IsSortTypeDESC": true, "IsPagination": true, "Page": 1, "PageSize": 100 }
let today = new Date();
let current_date = moment(today).format(dateFormat);
today.setDate(today.getDate() - 7);
let LastWeek = moment(today).format(dateFormat);

today = new Date();
today.setDate(today.getDate() - 14);
let Last2Week = moment(LastWeek).format(dateFormat);

today = new Date();
today.setMonth(today.getMonth() - 1);
let Pastmonthdate = moment(today).format(dateFormat);

let tablesjson = {
    
    Tesouraria: {
        columnkeyMap: {
            numero: "Número",
            estado: "Estado",
            tipoFatura: "Tipo de Fatura",
            tipoPagamento: "Tipo de Pagamento",
            valorTotal: "Valor (€)",
            dataCriado: "Emitido em",
            dataPagamento: 'Pago em',
        },
        actionbuttons: { RedirectTwo: "Detalhes" , PdfToo: "pdf"  },// Redirect: "Emitir Fatura",
        listApilink: "Receita/GetFaturas",
        requestMethod: "get",
        notAction: false,
        totalPageHeading: "Avaliações realizadas a aguardar",
        Filters: {
       
        },
        groupfield: [],
    },
    Penhoras: {
        columnkeyMap: {
            nome: "Entidade Penhorada",
            entidadeOrdenante: "Entidade Ordenante",
            dataPenhora: "Data da Penhora",
            dataEntrada: "Data de Entrada",
            valorPenhoraInicial: "Valor Penhora (€)",
            total_pago: "Total Pago (€)",
            valor_em_Divida: "Valor Divida (€)",
            penhoraEstado: "Estado",
            dataCriado: "Data de Criação",
        },
        actionbuttons: {MakePenhora: "MakePenhora"},// Redirect: "Emitir Fatura",
        listApilink: "Receita/GetPenhoras",
        requestMethod: "get",
        notAction: false,
        totalPageHeading: "Lista de penhoras concluídas ",
        Filters: {
       
        },
        groupfield: [],
    },
    Conta: {
        columnkeyMap: {
            nome: "Entidade",
            nib: "IBAN",
            ativo: "Ativo",
            irrevogavel: "Irrevogável",
        },
        actionbuttons: {MakeNIBS: "MakeNIBS"},// Redirect: "Emitir Fatura",
        //actionbuttons: {AutoButton: "Detalhes" , PdfToo: "pdf", PdfTooFatura: "Fatura" , Desselagem:"Desselagem"},// Redirect: "Emitir Fatura",
        listApilink: "Receita/GETNibs",
        requestMethod: "get",
        notAction: false,
        totalPageHeading: "Lista de Conta concluídas ",
        Filters: {
       
        },
        groupfield: [],
    }
}





class RevenueTables extends Component {
    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            linkData: tablesjson[this.props.tableName],
            telkikTable: null,
            popUpForm: null,
            tlkState: null,
            totalcount: 0,
            findnonDocumentedRow: 0,
            error : null,
            filtroEntidade: null,
            invoice: null
        }
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount = () => {
        this.defaultState();
    }

    /* Esta função irá chamar automaticamente quando o estado da página mudar  */
    componentDidUpdate = (preProp) => {
        if (preProp.date !== this.props.date || preProp.tableName !== this.props.tableName) {
            console.log("update",this.props,preProp)
            this.defaultState();
        }
        // if (preProp.date !== this.props.date || preProp.tableName !== this.props.tableName) {
        //     this.defaultState();
        // }
    }


    /* Para obter filtros para a API */
    getAllFilter = () => {
       
        let Request = { ...listdefaultRequest };
        Request.Filters = this.state.linkData.Filters;
        Request.Filters = { ...Request.Filters, ...this.props.applyedfilter }
        console.log("Request" ,Request)
       
        this.setState({
            filtroEntidade: Request.Filters.entityIdFilter,
        });
        console.log("STATE" , Request.Filters.entityIdFilter)
       
        console.log("Fileter", Request.Filters);
        if (Request.Filters.entity_id === undefined) {
            Request.Filters.entity_id = null
        }
        Request.Filters.local = null // window.localStorage.getItem('Local');
        if (this.props.tableName === "Faturas" && Request.Filters.entity_id > 0) {
            Request.Filters.is_paid = null;
        }

        var requestEntidade = Request.Filters.entityIdFilter;
        if(requestEntidade == undefined){
            requestEntidade = 0
        }else{
            requestEntidade = Request.Filters.entityIdFilter;
        }
        var SecundaryRequest = {"IDEntidade": requestEntidade}
        console.log("CENASSSSSSSSSS" ,SecundaryRequest)
        return SecundaryRequest ;
    }


    /*  Para excluir uma linha da base de dados no servidor */

    handleDelete = async (id) => {
        let link = this.state.linkData.deleteAPILink;
        let res = await services.apiCall.requestApi(link + "/" + id, {}, 'post')
        if (res) {
            this.defaultState();
        }
    }

    /* Carregar estado de página padrão  */

    defaultState = () => {
        let linkData = { ...tablesjson }
        linkData = tablesjson[this.props.tableName];
        this.setState({
            linkData: linkData,
            findnonDocumentedRow: 0,
            tlkState: {
                take: 100,
                skip: 0,
                group: [],
                exporting: false,
            }
        }, () => this.getListData())
    }

    /*Para obter dados para a tabela usando apis */

    getListData = async () => {
        try {
            if (!this.state.linkData) return
            let Request = this.getAllFilter();
            if (this.state.linkData.singleEntity) {
                this.setState({
                    totalcount: 0,
                    telkikTable: null,                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
                })
            }
            if (this.state.linkData.singleEntity && (!Request.Filters.entity_id && !Request.Filters.invoice_id)) return
            let method = this.state.linkData.requestMethod;
            let link = this.state.linkData.listApilink;
            let columnkeyMap = this.state.linkData.columnkeyMap;
            console.log("OUTRO OBJETO" , Request)
            const res = await services.apiCall.requestApi(link, Request, method);
            var invoicecode = [];
            let findnonDocumentedRow = 0;
         
            if (res && res.length > 0) {
                res.map((_row, index) => {
                    if (_row.invoiceHistory && _row.invoiceHistory.length > 0) {
                        
                        _row.invoiceHistory.map((_r, i) => {
                            invoicecode = [];
                            if (_r.file_Link && _r.invoiceType) {
                                invoicecode = _r.invoiceType.split("-");
                                if (invoicecode[0] === "IVF" || invoicecode[0] === "IVP" || invoicecode[0] === "API") {
                                    _row.document_url = "/api/" + _r.file_Link.replace("file:///C:/DevelopmentIVPD", "");
                                } else {
                                    _row.invoice_url = "/api/" + _r.file_Link.replace("file:///C:/DevelopmentIVPD", "");
                                }
                            } else {
                                findnonDocumentedRow = findnonDocumentedRow + 1;
                            }
                        })
                    } else {
                        findnonDocumentedRow = findnonDocumentedRow + 1;
                        console.log("AGORA" , _row)
                    }
                    Object.keys(columnkeyMap).map(function (key ) {
                        if (key === "n doc") {
                            _row[columnkeyMap[key]] = _row.no
                        } else if (key === "Entidade") {
                            _row[columnkeyMap[key]] = _row.busEntidade.nome

                        }else if (key === "dataCriado") {
                            _row[columnkeyMap[key]] = _row.dataCriado
                                ? moment(_row.dataCriado).format(
                                    fullDateFormat
                                  )
                                : "nd";
                                
                        }else if (key === "dataPenhora") {
                            _row[columnkeyMap[key]] = _row.dataPenhora
                                ? moment(_row.dataPenhora).format(
                                    fullDateFormat
                                  )
                                : "nd";
                            }else if (key === "dataEntrada") {
                                _row[columnkeyMap[key]] = _row.dataEntrada
                                    ? moment(_row.dataEntrada).format(
                                        fullDateFormat
                                      )
                                    : "nd";
                                }
                                else if (key === "ativo") {
                                    if(_row.ativo == true){
                                        _row[columnkeyMap[key]] = "Sim"
                                    }else{
                                        _row[columnkeyMap[key]] = "Não"
                                    }                  
                                }
                                else if (key === "irrevogavel") {
                                    if(_row.irrevogavel == true){
                                        _row[columnkeyMap[key]] = "Sim"
                                    }else{
                                        _row[columnkeyMap[key]] = "Não"
                                    }                  
                                }
                                    else if (key === "dataEntrada") {
                                        _row[columnkeyMap[key]] = _row.dataEntrada
                                            ? moment(_row.dataEntrada).format(
                                                fullDateFormat
                                              )
                                            : "nd";
                                        }else if (key === "dataPagamento") {
                            _row[columnkeyMap[key]] = _row.dataPagamento
                                ? moment(_row.dataPagamento).format(
                                    fullDateFormat
                                  )
                                : "nd";
                        } else if (key === "entityObject") {
                            _row[columnkeyMap[key]] = _row.entity_id ? _row.entityObject.nome : ""
                        } else if (key === "flag") {
                            _row[columnkeyMap[key]] = _row['flag'];
                        } else if (key === "Invoice_date" || key === "issue_date_time") {
                            _row[columnkeyMap[key]] = moment(_row['issue_date_time']).format(dateFormat);
                        } else if (key === "pag_limit") {
                            _row[columnkeyMap[key]] = _row['deadline_date'] ? moment(_row['deadline_date']).format(dateFormat) : moment(_row['issue_date_time']).format(dateFormat);
                        } else if (key === "is_doc_generated") {
                            _row[columnkeyMap[key]] = parseInt(_row['is_doc_generated']) === 1 ? "Sim" : "Não";
                        } else if (key === "Interest_to_date") {
                            _row[columnkeyMap[key]] = services.money.format(_row.service_tax);
                        } else if (key === "Valor c/ IVA") {
                            _row[columnkeyMap[key]] = services.money.format(_row.total_amount);
                        } else if (key === "valor_cativo") {
                            _row[columnkeyMap[key]] = services.money.format(_row.valor_cativo);
                        } else if (key === "Valor IVA") {
                            _row[columnkeyMap[key]] = services.money.format(_row.iva);
                        } else if (key === "add_Amonut_text") {
                            _row[columnkeyMap[key]] = _row.allTransaction && _row.allTransaction[0] ? _row.allTransaction[0].comment : "";
                        } else if (key === "for_invoice_id") {
                            _row[columnkeyMap[key]] = _row.for_invoice_id ? "Pagamento da Fatura" : "Pagamento Antecipado";
                        } else if (key === "is_paid") {
                            _row[columnkeyMap[key]] = _row[key] === 0 ? "Pendente" : "Não Pendente";
                        } else if (key === "Amount_paid") {
                            _row[columnkeyMap[key]] = services.money.format(_row['amount_paid']);
                        } else if (key === "outgoingAmount" && _row['document_type'] === 'Invoice') {
                            _row[columnkeyMap[key]] = services.money.format(_row.total_amount);
                        } else if (key === "incomingAmount" && _row['document_type'] === 'Credit') {
                            _row[columnkeyMap[key]] = services.money.format(_row.total_amount);
                        } else if (key === "valor") {
                            _row["valor"] = _row.trans_type === "CR" ? _row.total_cr : "-" + _row.total_dr;
                            _row[columnkeyMap[key]] = services.money.format(_row["valor"]);
                        } else if (key === "nifap") {
                            _row[columnkeyMap[key]] = _row.busEntidadeDetail.nifap
                        }  else if (key === "trans_date") {
                            _row[columnkeyMap[key]] = moment(_row['trans_date']).format(dateFormat);
                        } else if (key === "current_balance") {
                            _row[columnkeyMap[key]] = services.money.format(_row["current_balance"]);
                        } else if (key === "total_amount") {
                            _row[columnkeyMap[key]] = services.money.format(_row["total_amount"]);
                        } else if (key === "local") {
                            _row[columnkeyMap[key]] = _row["key"] || '';
                        } else if (key === "amount_paid") {
                            _row[columnkeyMap[key]] = services.money.format(_row[key]);
                        } else if (key === "trans_amount") {
                            _row[columnkeyMap[key]] = services.money.format(_row["trans_amount"]);
                        } else if (key === "balance") {
                            _row[columnkeyMap[key]] = services.money.format(_row["balance"]);
                        } else if (key === "valorTotal") {
                            _row[columnkeyMap[key]] = _row["valorTotal"] != '' ? _row["valorTotal"].toFixed(2) : '0,00';
                        } else if (key === "valorPenhoraInicial") {
                            _row[columnkeyMap[key]] = _row["valorPenhoraInicial"] != '' ? _row["valorPenhoraInicial"].toFixed(2) : '0,00';
                        } else if (key === "valor_em_Divida") {
                            _row[columnkeyMap[key]] = _row["valor_em_Divida"] != '' ? _row["valor_em_Divida"].toFixed(2) : '0,00';
                        }else if (key === "total_pago") {
                            _row[columnkeyMap[key]] = _row["total_pago"] != '' ? _row["total_pago"].toFixed(2) : '0,00';
                        }

                        // else if(key==="document_type" && _row.document_type==="Invoice") {
                        //     _row.document_type = "Movements"
                        // }else if(key==="document_type" && _row.document_type==="Credit") {
                        //     _row.document_type = "Crédito"
                        // }
                        else
                            _row[columnkeyMap[key]] = _row[key]
                    })
                    if (_row.document_type === "Invoice") {
                        _row.document_type = "Movements"
                    } else if (_row.document_type === "Credit") {
                        _row.document_type = "Crédito"
                    }
                });
                console.log("Akash","1",res);
                window.localStorage.setItem('table_total', res.length);
                this.setState({
                    data: res,
                    filterData: res,
                    totalcount: window.localStorage.getItem("table_total"),
                    findnonDocumentedRow
                }, () =>{
                    console.log("Akash","2");
                    this.createTabel()
                });
            }else{
                this.setState({
                    data: res,
                    filterData: res,
                    totalcount:0
                },()=>{
                    this.createTabel()
                })
            }
        } catch (error) {
            this.setState({error})
        }
    }

    /* Para carregar o componente da tabela e definir todas as colunas  */

    createTabel = () => {
        // let Request = { ...listdefaultRequest };
        // Request.Filters = this.state.linkData.Filters;
        // Request.Filters = { ...Request.Filters, ...this.props.applyedfilter }
        // console.log("Request" ,Request)
        
        // console.log("STATE" , Request.Filters.entityIdFilter)
        // console.log("Akash","3" , Request.Filters.entityIdFilter);
        if (this.state.linkData && this.state.linkData.columnkeyMap) {
            let columnkeyMap = {...this.state.linkData.columnkeyMap}
            if (this.state.findnonDocumentedRow === 0) {
                delete columnkeyMap["Check"]
            }
            
            let columnlist = Object.keys(columnkeyMap).map(function (key) {
                if(key == "valorPenhoraInicial" || key == "total_pago" || key == "valor_em_Divida" ){
                    return { field: columnkeyMap[key], columnMenuType: 'number' }
                }else{
                    return { field: columnkeyMap[key], columnMenuType: 'checkbox' }
                }
                
            });
            let actionbuttons = this.state.linkData.actionbuttons || {};
            console.log("columnlist",columnlist);
            console.log("filterData",this.state.filterData);
            
            let telkikTable = (
            <TlkTable
                date={new Date()}
                generateDocument={this.state.findnonDocumentedRow === 0 ? null : this.state.linkData.generateDocument}
                noDownloadButton={this.state.linkData.noDownloadButton}
                DocumentGERFIP={this.state.linkData.DocumentGERFIP}
                actionColumnName={this.state.linkData.actionColumnName}
                groupfield={this.state.linkData.groupfield}
                modulename={this.state.linkData.modulename || "fordefault"}
                notAction={this.state.linkData.notAction}
                //tlkState={this.state.tlkState}
                pageable={true}
                notGroup={true}
                deleteFunc={(id) => this.props.handleDelete(id)}
                //tableFilters={(filter) => this.tableFilters(filter)}
                list={this.state.filterData}
                actionbuttons={actionbuttons}
                columnlist={columnlist}
                ActionPerform={(action, id) => this.ActionPerform(action, id)} 
                
                />
            );
            this.setState({
                telkikTable: telkikTable
            })
        }
    }

    /* Obter filtros aplicados na tabela para atualização dinâmica */
    // tableFilters = (tlfilter) => {
    //     console.log("tlfilter",tlfilter);
    //     try{
    //         if(JSON.stringify(tlfilter) !== JSON.stringify(this.state.tlkState)){
    //             let customfilters = this.getAllFilter();
    //             let columnkeyMap = this.state.linkData.columnkeyMap;
    //             let tlkState = { ...tlfilter };
    //             let data = this.makeTlkFilters(tlfilter, columnkeyMap, customfilters);
    //             let linkData = { ...this.state.linkData };
            
    //             // linkData.Filters = data.Filters
    //             this.setState({
    //                 tlkState,
    //                 linkData
    //             }, () => this.getListData());
    //         }
    //     }catch(error){
    //         this.setState({error : error})
    //     }
    //     // return data;
    // }
    tableFilters = (tlfilter) => {
        // console.log("tlfilter",tlfilter);
        try {
            let customfilters = this.getAllFilter();
            let columnkeyMap = this.state.linkData.columnkeyMap;
            let tlkState = { ...tlfilter };
            let data = this.makeTlkFilters(
                tlfilter,
                columnkeyMap,
                customfilters
            );
            let linkData = { ...this.state.linkData };

            // linkData.Filters = data.Filters
            this.setState(
                {
                    tlkState,
                    linkData,
                },
                () => this.getListData()
            );
        } catch (error) {
            this.setState({ error: error });
        }
        // return data;
    };

    /* Alterações de filtro de tabela em formatos de API */
    makeTlkFilters = (tlkfilter, columnkeyMap, data) => {
        let tlkState;
        let inFilters = {};
        let columnkeyMaprev = {};
        // console.log("-----------pppppppppp",columnkeyMap)
        for (var key in columnkeyMap) {
            columnkeyMaprev[columnkeyMap[key]] = key;
        }
        if (
            tlkfilter.filter &&
            tlkfilter.filter.filters &&
            tlkfilter.filter.filters.length > 0
        ) {
            let tkkey = "";
            let tkkeyvalues = [];
            tlkfilter.filter.filters.map((_row, i) => {
                tkkey = "";
                tkkeyvalues = [];
                let checkamount = [];
                if (_row.filters && _row.filters.length > 0) {
                    _row.filters.map((_srow, k) => {
                        tkkey = _srow.field;
                        _srow.value = _srow.value ? _srow.value : "";
                        checkamount = _srow.value.split(" ");
                        if (checkamount[1] && checkamount[1] === "€") {
                            checkamount[0] = checkamount[0].replace(".", "");
                            checkamount[0] = checkamount[0].replace(",", ".");
                            _srow.value = checkamount[0];
                        }
                        _srow.value = $.isNumeric(_srow.value)
                            ? Number(_srow.value)
                            : _srow.value;
                        tkkeyvalues.push(_srow.value);
                    });
                    tkkey = columnkeyMaprev[tkkey];
                    tkkey = tkkey.toLowerCase();
                    inFilters[tkkey] = tkkeyvalues;
                }
            });
        }
        let defaultRequest = listdefaultRequest;
        defaultRequest.Page = tlkfilter.skip
            ? tlkfilter.skip / tlkfilter.take + 1
            : 1;
        defaultRequest.PageSize = tlkfilter.take ? tlkfilter.take : 100;
        if (tlkfilter && tlkfilter.sort && tlkfilter.sort.length > 0) {
            defaultRequest.SortBy = columnkeyMaprev[tlkfilter.sort[0].field];
            defaultRequest.IsSortTypeDESC =
                tlkfilter.sort[0].dir === "asc" ? false : true;
        }
        // data.inFilters = inFilters;
        return data;
    };
    // makeTlkFilters = (tlkfilter, columnkeyMap, data) => {
    //     let tlkState
    //     let inFilters = {};
    //     let columnkeyMaprev = {};
    //     // console.log("-----------pppppppppp",columnkeyMap)
    //     for (var key in columnkeyMap) {
    //         columnkeyMaprev[columnkeyMap[key]] = key;
    //     }
    //     if (tlkfilter.filter && tlkfilter.filter.filters && tlkfilter.filter.filters.length > 0) {
    //         let tkkey = "";
    //         let tkkeyvalues = [];
    //         tlkfilter.filter.filters.map((_row, i) => {
    //             tkkey = "";
    //             tkkeyvalues = [];
    //             let checkamount = [];
    //             if (_row.filters && _row.filters.length > 0) {
    //                 _row.filters.map((_srow, k) => {
    //                     tkkey = _srow.field;
    //                     _srow.value=_srow.value ?_srow.value : ""
    //                     checkamount =  _srow.value.split(" ")
    //                     if (checkamount[1] && checkamount[1] === "€") {
    //                         checkamount[0] = checkamount[0].replace(".", "");
    //                         checkamount[0] = checkamount[0].replace(",", ".");
    //                         _srow.value = checkamount[0];
    //                     }
    //                     _srow.value = $.isNumeric(_srow.value) ? Number(_srow.value) : _srow.value;
    //                     tkkeyvalues.push(_srow.value)
    //                 })
    //                 tkkey = columnkeyMaprev[tkkey];
    //                 tkkey = tkkey.toLowerCase();
    //                 inFilters[tkkey] = tkkeyvalues;
    //             }
    //         })
    //     }
    //     let defaultRequest = listdefaultRequest;
    //     defaultRequest.Page = tlkfilter.skip ? (tlkfilter.skip / tlkfilter.take + 1) : 1;
    //     defaultRequest.PageSize = tlkfilter.take ? tlkfilter.take : 100;
    //     if (tlkfilter && tlkfilter.sort && tlkfilter.sort.length > 0) {
    //         defaultRequest.SortBy = columnkeyMaprev[tlkfilter.sort[0].field];
    //         defaultRequest.IsSortTypeDESC = (tlkfilter.sort[0].dir === "asc") ? false : true;
    //     }
    //     // data.inFilters = inFilters;
    //     return data;
    // }

    /*  Para realizar a ação com base na seleção da tabela  */

    ActionPerform = (action, row) => {
        console.log("action perform")
        if (this.props.ActionPerform) {
            this.props.ActionPerform(action, row)
        } else {
            let popUpForm = null;
        }

        if(action == "PdfToo"){
            (async () => {
                const dataToken = {"idFatura": row.detalheURL}
                    const Detalhes = await services.apiCall.requestApi(
                    "/Receita/GetFaturaDetalhe",
                    dataToken,
                    "get"
                );

                this.setState({ invoice: Detalhes.pdf });

                var file = this.b64toBlob(this.state.invoice, 'application/pdf');
                //If the browser is IE or Edge
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(file);
                }
                else {
                    var fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }
            })();

           
        }else if(action == "MakePenhora"){
            var caminho = window.location.pathname
            window.location.href = `/criacao_penhora?&idPenhora=${row.detalheURL}`
        }else if(action == "MakeNIBS"){
            var caminho = window.location.pathname
            window.location.href = `/criacao_Conta?&idnib=${row.detalheURL}`
        }else{
            var caminho = window.location.pathname
            window.location.href = `/revenue_criacao?&idFatura=${row.detalheURL}`
        }
       
        console.log(action, row);
        console.log(window.location.pathname, "row cen")
    }
    b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);

          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, {type: contentType});
        return blob;
  }
  
    /*  Para renderizar o conteúdo html da página   */

    render() {
        if(this.state.error){
            throw this.state.error;
        }
        return (
            // <>
            //     <div className="custom-k-grid table-section">
            //         <div className="table-responsive">
            //             {this.state.telkikTable && (
            //                 <>
            //                     <h3>
            //                         {tablesjson[this.props.tableName] &&
            //                         tablesjson[this.props.tableName]
            //                             .totalPageHeading
            //                             ? tablesjson[this.props.tableName]
            //                                   .totalPageHeading +
            //                               "(" +
            //                               this.state.totalcount +
            //                               ")"
            //                             : `A pesquisa retornou ${this.state.totalcount} registos`}
            //                     </h3>
            //                     {this.state.telkikTable}
            //                 </>
            //             )}

            //             {this.state.totalcount == 0 && (
            //                 <div className="searct-found">
            //                     <img
            //                         alt="Não foram identificados registos com os critérios indicados"
            //                         className="img-fluid"
            //                         src="imgs/data-rotulos.png"
            //                     />
            //                     {this.state.showSearchMsg ? (
            //                         <p className="font-14">Não foram identificados registos com os critérios indicados</p>
            //                     ) : (
            //                         <h3>
            //                             Sem pedidos pendentes
            //                         </h3>
            //                     )}
            //                 </div>
            //             )}
            //         </div>
            //     </div>
            // </>
             <div className="custom-k-grid table-section">
                <div className="table-responsive">
                
                {
                  this.state.totalcount == 0 ? 
                  <div className="searct-found">
                    <img className="img-fluid" src="imgs/search-large-icon.png" />
                    {
                      this.state.showSearchMsg ? <p className="font-14">Sem resultados</p> : <h3>Pesquise uma entidade para apresentação de mais informações</h3>
                    }
                  </div>:
                  this.state.telkikTable &&
                  <>
                      <h3>{tablesjson[this.props.tableName] && tablesjson[this.props.tableName].totalPageHeading ? tablesjson[this.props.tableName].totalPageHeading + "("+this.state.totalcount+")" :`A pesquisa retornou ${this.state.totalcount} registos`}</h3>
                      {
                          this.state.telkikTable
                      }
                  </>
                }

                </div>
            </div>
        );
    }
}

export default RevenueTables;